import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://nthravcrioaegtkeowzz.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im50aHJhdmNyaW9hZWd0a2Vvd3p6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzEyNzIzOTEsImV4cCI6MTk4Njg0ODM5MX0.EKKW2cxo2u5oQHCZOOKvoPF9pI_xTeRmDzWBTe4Gc8s";
export const supabase = createClient(supabaseUrl, supabaseKey);
